interface LoginHeaderProps {
  className?: string;
}

export function LoginHeader({ className = '' }: LoginHeaderProps) {
  return (
    <div className={`text-center mb-8 ${className}`}>
      <h1 className="text-[32px] font-bold text-[#222222] mb-4">에코딜 시작하기</h1>
      <p className="text-[20px] font-semibold text-[#222222] leading-relaxed">
        로그인이 필요한 서비스입니다.<br />
        로그인해주세요.
      </p>
    </div>
  );
}